
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// const CertifyJobSeekers = () => {
//   const [jobSeekers, setJobSeekers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [userType, setUserType] = useState('');
//   const [certifying, setCertifying] = useState({}); // Track per-jobSeeker loading state

//   // Fetch jobSeekers and userType on mount
//   useEffect(() => {
//     const fetchJobSeekers = async () => {
//       setLoading(true);
//       try {
//         const token = localStorage.getItem('token');
//         const userId = localStorage.getItem('superAdminId') || localStorage.getItem('userId');
//         if (!token || !userId) {
//           toast.error('Please log in to continue');
//           return;
//         }

//         // Fetch user to get userType
//         const userResponse = await axios.get(`${process.env.REACT_APP_API_URL}admin/${userId}`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setUserType(userResponse.data.userType);

//         // Fetch jobSeekers
//         const response = await axios.get(`${process.env.REACT_APP_API_URL}jobseeker/allJobSeeker`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setJobSeekers(response.data);
//       } catch (error) {
//         console.error('Error fetching jobseekers:', error);
//         toast.error(error.response?.data?.message || 'Failed to fetch jobseekers');
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchJobSeekers();
//   }, []);

//   // Handle certification
//   const handleCertify = async (jobSeekerId) => {
//     setCertifying((prev) => ({ ...prev, [jobSeekerId]: true }));
//     try {
//       const token = localStorage.getItem('token');
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}jobseeker/certify/${jobSeekerId}`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setJobSeekers((prev) =>
//         prev.map((js) =>
//           js._id === jobSeekerId
//             ? {
//                 ...js,
//                 isCertified: true,
//                 certificationDate: new Date(response.data.jobSeeker.certificationDate),
//                 certifiedBy: response.data.jobSeeker.certifiedBy,
//               }
//             : js
//         )
//       );
//       toast.success(response.data.message || 'JobSeeker certified successfully');
//     } catch (error) {
//       console.error('Certification error:', error);
//       toast.error(error.response?.data?.message || 'Failed to certify JobSeeker');
//     } finally {
//       setCertifying((prev) => ({ ...prev, [jobSeekerId]: false }));
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
//       <h2 className="text-3xl font-bold text-gray-800 mb-6">Certify JobSeekers</h2>
//       {loading ? (
//         <div className="flex justify-center">
//           <div className="animate-spin h-8 w-8 border-4 border-t-4 border-t-orange-500 border-gray-200 rounded-full"></div>
//         </div>
//       ) : jobSeekers.length > 0 ? (
//         <div className="bg-white p-6 rounded-lg shadow-lg">
//           <table className="w-full text-sm md:text-base">
//             <thead className="bg-gray-100">
//               <tr>
//                 <th className="py-2 px-4 text-left">Name</th>
//                 <th className="py-2 px-4 text-left">Email</th>
//                 <th className="py-2 px-4 text-left">Status</th>
//                 {userType === 'superadmin' && (
//                   <th className="py-2 px-4 text-left">Certified By</th>
//                 )}
//                 <th className="py-2 px-4 text-left">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {jobSeekers.map((jobSeeker) => (
//                 <tr key={jobSeeker._id} className="border-t">
//                   <td className="py-2 px-4">{`${jobSeeker.firstName} ${jobSeeker.lastName}`}</td>
//                   <td className="py-2 px-4">{jobSeeker.email}</td>
//                   <td className="py-2 px-4">
//                     {jobSeeker.isCertified
//                       ? `Certified on ${new Date(jobSeeker.certificationDate).toLocaleDateString()}`
//                       : 'Not Certified'}
//                   </td>
//                   {userType === 'superadmin' && (
//                     <td className="py-2 px-4">{jobSeeker.certifiedBy?.fullName || 'N/A'}</td>
//                   )}
//                   <td className="py-2 px-4">
//                     {!jobSeeker.isCertified || (userType === 'superadmin' && jobSeeker.certifiedBy?.userType !== 'superadmin') ? (
//                       <button
//                         onClick={() => handleCertify(jobSeeker._id)}
//                         disabled={certifying[jobSeeker._id]}
//                         className={`px-4 py-2 rounded-lg text-white flex items-center justify-center transition
//                           ${certifying[jobSeeker._id] ? 'bg-gray-400 cursor-not-allowed' : userType === 'superadmin' ? 'bg-orange-500 hover:bg-orange-600' : 'bg-green-500 hover:bg-green-600'}`}
//                       >
//                         {certifying[jobSeeker._id] ? (
//                           <div className="animate-spin h-5 w-5 border-2 border-t-2 border-t-white border-gray-200 rounded-full mr-2"></div>
//                         ) : null}
//                         {userType === 'superadmin' ? 'Certify (Superadmin)' : 'Certify'}
//                       </button>
//                     ) : jobSeeker.isCertified  ? (
//                       <button
//                         className="px-4 py-2 rounded-lg text-white bg-green-500 flex items-center justify-center transition cursor-default"
//                       >
//                         Certified by Superadmin
//                       </button>
//                     ) : (
//                       <span className="text-green-500">Certified by Admin</span>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       ) : (
//         <p className="text-gray-500 text-center">No jobseekers found.</p>
//       )}
//     </div>
//   );
// };

// export default CertifyJobSeekers;



import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CertifyJobSeekers = () => {
  const [jobSeekers, setJobSeekers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userType, setUserType] = useState('');
  const [certifying, setCertifying] = useState({}); // Track per-jobSeeker loading state

  // Capitalize userType for display (e.g., 'superadmin' -> 'Superadmin')
  const capitalizeUserType = (userType) => {
    if (!userType) return 'Unknown';
    return userType.charAt(0).toUpperCase() + userType.slice(1).replace(/([A-Z])/g, ' $1').trim();
  };

  // Fetch jobSeekers and userType on mount
  useEffect(() => {
    const fetchJobSeekers = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('superAdminId') || localStorage.getItem('userId');
        if (!token || !userId) {
          toast.error('Please log in to continue');
          return;
        }

        // Fetch user to get userType
        const userResponse = await axios.get(`${process.env.REACT_APP_API_URL}admin/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUserType(userResponse.data.userType);

        // Fetch jobSeekers
        const response = await axios.get(`${process.env.REACT_APP_API_URL}jobseeker/allJobSeeker`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setJobSeekers(response.data);
      } catch (error) {
        console.error('Error fetching jobseekers:', error);
        toast.error(error.response?.data?.message || 'Failed to fetch jobseekers');
      } finally {
        setLoading(false);
      }
    };
    fetchJobSeekers();
  }, []);

  // Handle certification
  const handleCertify = async (jobSeekerId) => {
    setCertifying((prev) => ({ ...prev, [jobSeekerId]: true }));
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}jobseeker/certify/${jobSeekerId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setJobSeekers((prev) =>
        prev.map((js) =>
          js._id === jobSeekerId
            ? {
                ...js,
                isCertified: true,
                certificationDate: new Date(response.data.jobSeeker.certificationDate),
                certifiedBy: response.data.jobSeeker.certifiedBy,
              }
            : js
        )
      );
      toast.success(response.data.message || 'JobSeeker certified successfully');
    } catch (error) {
      console.error('Certification error:', error);
      toast.error(error.response?.data?.message || 'Failed to certify JobSeeker');
    } finally {
      setCertifying((prev) => ({ ...prev, [jobSeekerId]: false }));
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <h2 className="text-3xl font-bold text-gray-800 mb-6">Certify JobSeekers</h2>
      {loading ? (
        <div className="flex justify-center">
          <div className="animate-spin h-8 w-8 border-4 border-t-4 border-t-orange-500 border-gray-200 rounded-full"></div>
        </div>
      ) : jobSeekers.length > 0 ? (
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <table className="w-full text-sm md:text-base">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-2 px-4 text-left">Name</th>
                <th className="py-2 px-4 text-left">Email</th>
                <th className="py-2 px-4 text-left">Status</th>
                {userType === 'superadmin' && (
                  <th className="py-2 px-4 text-left">Certified By</th>
                )}
                <th className="py-2 px-4 text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {jobSeekers.map((jobSeeker) => (
                <tr key={jobSeeker._id} className="border-t">
                  <td className="py-2 px-4">{`${jobSeeker.firstName} ${jobSeeker.lastName}`}</td>
                  <td className="py-2 px-4">{jobSeeker.email}</td>
                  <td className={`py-2 px-4 ${jobSeeker.isCertified ? 'bg-green-400' : 'bg-orange-400'}`}>
                    {jobSeeker.isCertified
                      ? `Certified on ${new Date(jobSeeker.certificationDate).toLocaleDateString()}`
                      : 'Not Certified'}
                  </td>
                  {userType === 'superadmin' && (
                    <td className="py-2 px-4">{jobSeeker.certifiedBy?.fullName || 'N/A'}</td>
                  )}
                  <td className="py-2 px-4">
                    {jobSeeker.isCertified ? (
                      <button
                        className="px-4 py-2 rounded-lg text-white bg-green-500 flex items-center justify-center transition cursor-default"
                      >
                        Certified by superAdmin 
                        {/* Certified by  {capitalizeUserType(jobSeeker.certifiedBy?.userType || superAdmin)  } */}
                      </button>
                    ) : (
                      <button
                        onClick={() => handleCertify(jobSeeker._id)}
                        disabled={certifying[jobSeeker._id]}
                        className={`px-4 py-2 rounded-lg text-white flex items-center justify-center transition
                          ${certifying[jobSeeker._id] ? 'bg-gray-400 cursor-not-allowed' : userType === 'superadmin' ? 'bg-orange-500 hover:bg-orange-600' : 'bg-green-500 hover:bg-green-600'}`}
                      >
                        {certifying[jobSeeker._id] ? (
                          <div className="animate-spin h-5 w-5 border-2 border-t-2 border-t-white border-gray-200 rounded-full mr-2"></div>
                        ) : null}
                        Certify
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-gray-500 text-center">No jobseekers found.</p>
      )}
    </div>
  );
};

export default CertifyJobSeekers;
